import './bones-config';

import '../../scss/style.scss';

import './jquery-appear';
import './mobile-nav';
import {genericSocialShare} from './social-sharing';

window.genericSocialShare = genericSocialShare;


import Vue from 'vue';

const app = new Vue({
    el        : '#container',
    components: {
        Hello: () => import('./VueComponents/Hello.vue')
    }
});


jQuery(document).ready(function($) {
    var $button = $('.collapsible-trigger');
    var activeClass = 'is-active';
    var collapsible = '.collapsible';

    $button.each( function() {
        $(this).click(function() {
            event.preventDefault();
            $(this).parent().toggleClass(activeClass);
            // $(this).siblings(collapsible).slideToggle(400);
        });
    });

}(jQuery));


jQuery(document).ready(function($) {	
    function scrollToSection(event) {
        event.preventDefault();

        var $section = $($(this).attr('href'));
        
        $('html, body').animate({
            scrollTop: $section.offset().top
        }, 500);
    }
    $('[data-scroll]').on('click', scrollToSection);
}(jQuery));





jQuery(document).ready(function($) {

	$('.full-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
	});

	$('.variable-slider').slick({
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 5000,
		centerMode: true,
  		variableWidth: true
	});

	console.log('Hiya');

}(jQuery));


// WEBPACK FOOTER //
// ./library/js/src/app.js